import { ListService, PagedResultDto } from '@abp/ng.core';
import { ToasterService } from '@abp/ng.theme.shared';
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { QueueItemDto } from '@proxy/queue-service';
import {
  AssetDetailsDto,
  AssetService,
  AssetTransferableParts,
} from '@proxy/register-service/assets';
import { LocationDto, LocationService } from '@proxy/register-service/locations';
import { DeallocationType } from '@register/proxy/register-service/assets';
import { LocationDefinition } from '@register/proxy/register-service/locations/location-type.enum';

@Component({
  selector: 'app-checkout-modal',
  templateUrl: './checkout-modal.component.html',
  styleUrls: ['./checkout-modal.component.scss'],
})
export class CheckoutModalComponent implements OnInit, OnChanges {
  @Input() asset: AssetDetailsDto;
  @Input() selectedIds: string[];
  @Input() showMessage = false;
  @Input() twoStepEnabled = false;
  @Input() transferData: AssetTransferableParts | null = null;
  @Input() openCheckoutModal: boolean;
  @Input() pinOrKeyringPassword: string = '';
  @Input() isGuest: boolean = false;
  @Input() selectedAssets: QueueItemDto[];

  @Output() modalClose = new EventEmitter<boolean>();
  @Output() openTransferModal = new EventEmitter();
  @Output() actionCompleted = new EventEmitter<void>();

  DeallocationType = DeallocationType;
  selectedLocation: LocationDto = null;
  locationDefinition: LocationDefinition = LocationDefinition.SECONDARY;
  actionType: string = '';
  data: PagedResultDto<LocationDto> = {
    items: [],
    totalCount: 0,
  };
  isBusy: boolean = true;
  hasSecondaryId = false;
  notes = '';
  private pendingAction = false;

  get hasTransfer(): boolean {
    const a = this.transferData && Object.keys(this.transferData).length > 0;
    return a;
  }

  constructor(
    public readonly list: ListService,
    public readonly service: LocationService,
    public readonly assetService: AssetService,
    public readonly toasterService: ToasterService
  ) {}

  ngOnInit(): void {
    this.hasSecondaryId =
      this.selectedAssets?.some(asset => !!asset.secondaryLocationName) ||
      Boolean(this.asset.secondaryLocationId);
  }

  selectLocation(location) {
    this.isBusy = false;
    this.selectedLocation = location;
  }
  performActionAndClose() {
    this.isBusy = true;
    const action = this.assetService.performAction({
      actionType: this.actionType,
      asset: this.asset,
      isQueue: !this.asset,
      assetIds: this.selectedIds,
      transferData: this.transferData,
      selectedLocation: this.selectedLocation,
      pinOrKeyringPassword: this.pinOrKeyringPassword,
      transferNotes: this.notes,
    });

    action.subscribe({
      next: () => {
        this.actionCompleted.emit();
        this.modalClose.emit(true);
        this.actionType = '';
        this.toasterService.success('RegisterService::Successful');
      },
    });
  }

  checkout() {
    this.actionType = 'checkOut';
    if (this.twoStepEnabled && this.asset.hasSubAssets && !this.hasTransfer) {
      this.pendingAction = true;
      this.openTransferModal.emit();
    } else {
      this.performActionAndClose();
    }
  }

  return() {
    this.actionType = 'return';
    if (this.twoStepEnabled && this.asset.hasSubAssets && !this.hasTransfer) {
      this.pendingAction = true;
      this.openTransferModal.emit();
    } else {
      this.performActionAndClose();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['transferData'] && this.pendingAction && this.hasTransfer) {
      this.pendingAction = false;
      this.performActionAndClose();
    }
  }
}
